import React from 'react';

import {useBootcampConfigContext} from '../../../contexts/BootcampConfig';
import {useUserDataContext} from '../../../contexts/UserData';

import CheatSheets from '@bootcamp/web/src/bootcamps/pages/CheatSheets';


function getIconUrl(config, classroom) {
  try {
    const url = config?.classrooms?.find(({name}) => name === classroom).icon;
    return require(`@bootcamp/shared/src/assets/${url}`).default;
  } catch (error) {
    console.log('error getting iconl', error);
  }
}

const INBDECheatSheets = ({history}) => {
  const {config} = useBootcampConfigContext();
  const {isUpgraded} = useUserDataContext();

  const items = config?.classrooms?.reduce((acc, classroom) => {
    return [
      ...acc,
      ...(classroom?.contentTypes?.find(({name}) => name === 'Cheat Sheets')?.content?.reduce((acc, {content}) => [...acc, ...(content || []).map(el => ({...el, classroom: classroom.name}))], [])|| [])
    ]
  }, []);

  const sortedItems = !isUpgraded
    ? [...items].sort((a, b) => a.freeAccess ? -1 : 1)
    : items;

  const formattedItems = sortedItems.map(({description, classroom, name, route, freeAccess}) => ({
    category: classroom,
    description,
    name,
    route,
    iconUrl: getIconUrl(config, classroom),
    freeAccess: isUpgraded ? true : freeAccess,
  }));

  const categories = [...new Set(items.map(item => item.classroom))];

  return (
    <CheatSheets
      items={formattedItems}
      subTitle={'Cheat Sheets'}
      body={'Bootcamp\'s high-yield INBDE cheat sheets are designed to save you time and help you pass.'}
      title={'Classroom'}
      history={history}
      categories={categories}
    />
  );
}

export default INBDECheatSheets;
